import React, { useEffect, useMemo, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import { logOut } from "../../../utils/logOut"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { useSelector } from "react-redux"
import { Card, CardActions, CardContent, Fade, Paper, Typography } from "@mui/material"
import { useSnackbar } from "../../../utils/SnackbarContext"
import TranslatedText from "../../../utils/Translate"
import SimplifiedTable from "../../../components/Table/SimpleTable"

export default function AIPrompts() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [partners, setPartners] = useState([])
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    const [filterParams, setFilterParams] = useState({
        partner: '',
        code: '',
    })

    const { showSnackbar } = useSnackbar();


    useEffect(() => {
        dispatch(setCurrentPage(`AI Prompts`))
    }, [dispatch]);

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )


    const truncateString = (s: string, w: number) => s.length > w ? s.slice(0, w) + "..." : s;

    //Get word group
    async function fetchData(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/aiprompt`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: { ...params, startRow, maxRows, calculatetotalcount: true }
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount)
                    setTableData(response.data.slice(1))
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data);

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }



    //on load - fetch data
    useEffect(() => {
        // fetchData(filterParams)
        accesslevel === "5" && getPartners()
    }, [])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filterParams])

    useEffect(() => {
        setTimeout(() => fetchData(filterParams), 0)
    }, [startRow, maxRows])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);


    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column', mr: 1 }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "100%", justifyContent: "space-between" }}>
                <Link to='/aiprompt' state={{ type: 'add' }}>
                    <Button size="small" sx={{ mr: 1 }} variant="outlined"><TranslatedText text={'Add AI Prompt'} /></Button>
                </Link>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: 'wrap', width: '100%', justifyContent: 'center' }}>
                    <TextField sx={{ maxWidth: 523, minWidth: 223, width: "70%" }} value={filterParams.code} onChange={(e) => setFilterParams({ ...filterParams, code: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Contains code'} />} />
                    {accesslevel == '5' &&
                        <FormControl>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Available to partner'} /></InputLabel>
                            <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, partner: e.target.value })} value={filterParams.partner} variant="outlined" size="small" label={<TranslatedText text={'Available to partner'} />} >
                                <MenuItem value={''}>Only Operator</MenuItem>
                                <MenuItem value={'0'}>All</MenuItem>
                                {
                                    partners.map((el: any) => (
                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>}
                    <Button onClick={() => fetchData(filterParams)} size="small" sx={{ mr: 1 }} variant="contained" > <TranslatedText text={'Apply'} /></Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                                {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                                    <>
                                        <SimplifiedTable rows={tableData} page={'aiprompt'} />
                                        <Fade in={!loading} timeout={300}>
                                            <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                                                <Box sx={{ mt: 2 }}>
                                                    <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                                    <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                                    <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                                    <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                                                </Box>
                                                <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                                                <Typography sx={{ pt: 2, ml: 2 }}>
                                                    <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                                                </Typography>
                                                <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                                            </Box>
                                        </Fade>
                                    </>
                                }

                                {/* {requestsData.map((el) => {
                                    return (
                                        <Card variant="outlined" sx={{ padding: 1, borderRight: `5px solid blue`, mb: 2 }}>
                                            <CardContent sx={{ width: '100%', flexWrap: 'wrap' }}>
                                                <Box sx={{ width: '100%', mb: 1 }}>
                                                    <Typography variant="h5" component="div">
                                                        {el.name}
                                                    </Typography>
                                                    <Typography color="text.secondary">
                                                        {el.code}
                                                    </Typography>
                                                </Box>
                                            </CardContent>
                                            <CardActions sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                                <Button variant='outlined' size="small">EDIT AI PROMPT</Button>
                                                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                    Function call mode: {el.funcmode}
                                                </Typography>
                                                {accesslevel == '5' &&
                                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                        Show the setting to a partner: {el.showsetuptopartner}
                                                    </Typography>}
                                                {accesslevel == '5' &&
                                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                        Available to partners: {el.availavletopartners}
                                                    </Typography>}
                                            </CardActions>
                                        </Card>
                                    )
                                })} */}
                </>}
        </Box>
    )
}